import React from "react";

/**
 * Line-items table. Responsive: renders as a proper <table> on
 * desktop, collapses to stacked cards on mobile (via CSS media
 * queries on `.pay-invoice-items`).
 *
 * The backend's /info response pre-formats every amount as a
 * display string so the renderer never touches BigInt or does
 * any math here. `quantity` is a plain number (decimals allowed
 * up to 4 places for hourly billing).
 */
export function InvoiceLineItems({ lineItems }) {
  if (!Array.isArray(lineItems) || lineItems.length === 0) return null;
  return (
    <div className="pay-invoice-items">
      <table className="pay-invoice-items__table">
        <thead>
          <tr>
            <th>Description</th>
            <th className="pay-invoice-items__num">Qty</th>
            <th className="pay-invoice-items__num">Unit price</th>
            <th className="pay-invoice-items__num">Total</th>
          </tr>
        </thead>
        <tbody>
          {lineItems.map((li, i) => (
            <tr key={i}>
              <td>{li.description}</td>
              <td
                className="pay-invoice-items__num"
                data-label="Qty"
              >
                {formatQuantity(li.quantity)}
              </td>
              <td
                className="pay-invoice-items__num"
                data-label="Unit price"
              >
                {li.unitPriceDisplay}
              </td>
              <td
                className="pay-invoice-items__num pay-invoice-items__total"
                data-label="Total"
              >
                {li.totalDisplay}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/** Render fractional quantities cleanly — "1" stays "1", "1.5"
 *  stays "1.5", no trailing zeros. */
function formatQuantity(q) {
  const n = Number(q);
  if (!Number.isFinite(n)) return String(q);
  // Drop trailing zeros but keep meaningful decimals.
  return String(n);
}
